// extracted by mini-css-extract-plugin
export var border = "_1d-7";
export var brand = "_1d-s";
export var button = "_1d-k";
export var center = "_1d-9";
export var centered = "_1d-5";
export var closeButton = "_1d-b";
export var disabledWrapper = "_1d-l";
export var error = "_1d-o";
export var extraLarge = "_1d-4";
export var extraSmall = "_1d-1";
export var fill = "_1d-h";
export var footer = "_1d-g";
export var footerAction = "_1d-i";
export var footerButtons = "_1d-j";
export var header = "_1d-6";
export var headerWithClose = "_1d-c";
export var icon = "_1d-n";
export var info = "_1d-r";
export var inline = "_1d-8";
export var large = "_1d-3";
export var main = "_1d-d";
export var modal = "_1d-0";
export var neutral = "_1d-t";
export var noPadding = "_1d-f";
export var none = "_1d-u";
export var scrollable = "_1d-e";
export var small = "_1d-2";
export var success = "_1d-q";
export var tight = "_1d-m";
export var titleIcon = "_1d-a";
export var warn = "_1d-p";